import PropTypes from "prop-types";
import {kebabCase} from "@/helpers/kebabCase";
import {css} from "@emotion/react";

const QuickLinksItemBlade = ({quick_link_title}) => {

    const anchor = css(`
        position: relative;
        top: -70px;
    `);

    const name = kebabCase(quick_link_title.value)
    return <div css={anchor} id={name} />
};

QuickLinksItemBlade.propTypes = {
    quick_link_title: PropTypes.object
};

export default QuickLinksItemBlade;
